/**
 * **대표자 본인확인 줄 — 읽기 전용 표시 한 곳** (R-W 브리프 §1-7·§3). 의존성 없는 순수 모듈이다(Vue·Element·`@/` 별칭 금지).
 *
 * 매장 수정 화면(`GET /store/{cd}`)·사업장 상세(`GET /cust/{cd}`·`GET /cust/info`) 응답의 `ceoVerification`
 * `{mobileNo, verifiedDtm, current}` — 처음 받은 비밀번호 재설정에서 대표자 휴대폰을 확인한 그 사업자의 마지막 기록이다. 서버가 만들고
 * (시각은 한국 시각 문자열), 대행 계정(관리점·운영사)과 확인한 적 없는 사업자에는 싣지 않는다. 화면(`components/common/CeoVerificationLine.vue`)은
 * 이 줄을 그리기만 한다.
 */
// 확장자를 적는 이유: 단위 테스트가 앱 번들 밖(node)에서 읽는다 — node ESM 은 상대 경로 확장자를 추론하지 않는다.
import { telText } from './telNumber.js'

/** 화면 문구 — i18n 키가 한국어 문장 자체다 */
export const CEO_VERIFICATION_TEXT = Object.freeze({
  /** 확인 뒤 대표자명·사업자등록번호가 바뀌었다(`current: false`) */
  stale: '대표자 정보가 바뀐 뒤 다시 확인하지 않았습니다',
})

/**
 * 블록 → 줄. 블록이 없으면(`null`·없음) `null` — 아무것도 그리지 않는다.
 *
 * @param {?{mobileNo: string, verifiedDtm: string, current: boolean}} block 응답의 `ceoVerification`
 * @returns {?{text: string, stale: string}} `text` 「대표자 휴대폰 010-1234-5678 · 본인확인 2026-10-19 21:03」 · `stale` 덧붙일 말(지금 등록값과 같으면 빈 말)
 */
export function ceoVerificationLine(block) {
  if (!block || typeof block !== 'object') return null

  return {
    text: `대표자 휴대폰 ${telText(block.mobileNo)} · 본인확인 ${block.verifiedDtm}`,
    stale: block.current === false ? CEO_VERIFICATION_TEXT.stale : '',
  }
}
